import { render } from "./takePhoto.vue?vue&type=template&id=df9b2bd4&scoped=true"
import script from "./takePhoto.vue?vue&type=script&lang=js"
export * from "./takePhoto.vue?vue&type=script&lang=js"

import "./takePhoto.vue?vue&type=style&index=0&id=df9b2bd4&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df9b2bd4"]])

export default __exports__